<template>
	<div class="header">
        <div class="rule" style="height: 75px;">
            <div class="header-l">
                <div class="logo">
                	<img src="./../assets/img/Logo.png" alt="" />
                </div>
            </div>
            <div class="header-f">
            	<ul>
                	<li :class="$route.meta.parentMenu=='Index'?'active':(dao.get('hotelListSearchParams')&&dao.get('hotelListSearchParams').ProductType!=256&&$route.meta.parentMenu=='auto'?'active':'')" @click="$router.push('/')">酒店预订</li>
                    <li :class="$route.meta.parentMenu=='OrderList'?'active':''" @click="$router.push('/orderList')">订单管理</li>
                	
                </ul>
            </div>
            <div class="header-e">
                <div class="user" @mouseover="isShow=true" @mouseout="isShow=false">
                    您好，{{userInfo.CustomerNO}}
                    <ul class="head-menu" v-show="isShow">
                        <li :class="$route.path=='/baseInfo'?'menu-item active':'menu-item'" @click="$router.push('/baseInfo')"><i class="iconfont icon-zhanghuguanli"></i>账户管理</li>
                        <li :class="$route.path=='/orderList'?'menu-item active':'menu-item'" @click="$router.push('/orderList')"><i class="iconfont icon-yudingdan"></i>订单管理</li>
                        <li v-if="(userInfo.Power&4)==4" :class="$route.path=='/reportList'?'menu-item active':'menu-item'" @click="$router.push('/reportList')"><i class="iconfont icon-baobiao"></i>报表统计</li>
                       
                        <li v-if="(userInfo.Power&8)==8" :class="$route.path=='/invoice'?'menu-item active':'menu-item'" @click="$router.push('/invoice')"><i class="iconfont icon-fapiaoguanli" style="font-size: 18px;"></i>发票管理</li>
                        <li class="menu-item" @click="logout"><i class="iconfont icon-tuichu2"></i>退出账号</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name:'Header',
        data(){
            return{
                isShow:false,
                userInfo:this.dao.get('userInfo')||"",
            }
        },
        
        methods:{
            logout(){
                //登陆成功后，保存登陆信息到本地localstorage
                this.dao.set('userInfo','');
                this.$router.push('/login');
            },

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Header.vue